import { SetterOrUpdater } from 'recoil'

import { MachineSensorManager } from './states'
import { BayMachine, BayMachineList, MACHINE_STATUS } from './types'


export class BayGridSize {
  width = 0
  height = 0

  get isValid(): boolean {
    return this.width > 0 && this.height > 0
  }

  get countOfItems(): number {
    return this.width * this.height
  }

  getEmptyGrid(): unknown[][] {
    return Array.from({length: this.width}).map(() =>
      Array.from({length: this.height})
    )
  }
}

class BayManager {
  // 그리드 전역상태 관리용 세터
  gridMachineSetter?: SetterOrUpdater<BayMachineList>
  gridSizeSetter?: SetterOrUpdater<BayGridSize>

  private _machines?: BayMachineList

  get machines() {
    return this._machines || []
  }

  set machines(machineList: BayMachineList) {
    this._machines = machineList
  }

  private _serverTimeDiff = 0

  set serverTimeDiff(diff: number) {
    this._serverTimeDiff = diff
  }

  get serverNow() {
    return new Date(Date.now() + this._serverTimeDiff)
  }

  getMachineStatus(machine: BayMachine) {
    if (machine.userID) {
      // 타이머가 있는 경우
      // 남은시간이 없으면 END
      // 남은시간이 있으면 PRACTICE
      if (machine.timer) {
        return machine.timer.remainTime <= 0
          ? MACHINE_STATUS.END
          : MACHINE_STATUS.PRACTICE
      }

      // 타이머가 없을때 시작시간과 종료시간이 있으면
      // 지금막 연습시작한 경우로 보고 PRACTICE 상태로 바꾼다.
      if (machine.startDate && machine.endDate) {
        return MACHINE_STATUS.PRACTICE
      }

      // 유저정보만 존재하는 경우에는
      // 로그인만 완료한 경우로 보고 USE 상태로 바꾼다.
      return MACHINE_STATUS.USE
    }

    // 소켓아이디 값이 있으면 ON
    if (machine.socketID) return MACHINE_STATUS.ON

    return MACHINE_STATUS.OFF
  }

  setMachines(machineList: BayMachineList) {
    this.machines = machineList.map((machine) => {
      return {
        ...machine,
        status: this.getMachineStatus(machine),
        sensorManager: machine.sensorState
          ? new MachineSensorManager(machine.sensorState)
          : undefined,
      }
    })

    if (!this.gridMachineSetter) return

    this.gridMachineSetter(this.machines)
  }

  setMachineTimer() {
    if (!this.gridMachineSetter) return

    this.machines = this.machines.map((machine) => {
      if (machine.status !== MACHINE_STATUS.PRACTICE) return machine

      let remain = 0

      const end = new Date(machine.endDate!).getTime()
      const start = new Date(machine.startDate!).getTime()
      const whole = end - start

      remain = end - this.serverNow.getTime()

      const remainTime = remain > 0 ? remain : 0

      return {
        ...machine,
        timer: {
          remainTime,
          remainTimePercent: Math.floor((remainTime / whole) * 100),
        },
      }
    })

    this.gridMachineSetter(this.machines)
  }
}

export const bayManager = new BayManager()
